import { httpClient } from './http-client';

export interface Goal {
  id: string;
  household_id: string;
  name: string;
  target_amount: string;
  current_amount: string;
  currency: string;
  target_date?: string | null;
  icon?: string | null;
  color?: string | null;
  notes?: string | null;
  is_completed: boolean;
  completed_at?: string | null;
  percent_complete: string;
  created_at: string;
  updated_at: string;
}

export interface GoalContribution {
  id: string;
  goal_id: string;
  amount: string;
  date: string;
  notes?: string | null;
  created_at: string;
}

interface CreateGoalRequest {
  name: string;
  target_amount: string;
  currency?: string;
  target_date?: string;
  icon?: string;
  color?: string;
  notes?: string;
}

interface UpdateGoalRequest {
  name?: string;
  target_amount?: string;
  currency?: string;
  target_date?: string;
  icon?: string;
  color?: string;
  notes?: string;
  is_completed?: boolean;
}

interface AddContributionRequest {
  amount: string;
  date?: string;
  notes?: string;
}

export class GoalsService {
  private static readonly BASE_URL = '/goals';

  static async listGoals(includeCompleted = false): Promise<{ goals: Goal[] }> {
    const url = includeCompleted
      ? `${GoalsService.BASE_URL}?include_completed=true`
      : GoalsService.BASE_URL;
    const raw = await httpClient.get<any>(url);
    return (raw as any).data || raw;
  }

  static async getGoal(id: string): Promise<Goal> {
    const raw = await httpClient.get<any>(`${GoalsService.BASE_URL}/${id}`);
    return (raw as any).data || raw;
  }

  static async createGoal(data: CreateGoalRequest): Promise<Goal> {
    const raw = await httpClient.post<any>(GoalsService.BASE_URL, data);
    return (raw as any).data || raw;
  }

  static async updateGoal(id: string, data: UpdateGoalRequest): Promise<Goal> {
    const raw = await httpClient.put<any>(`${GoalsService.BASE_URL}/${id}`, data);
    return (raw as any).data || raw;
  }

  static async deleteGoal(id: string): Promise<void> {
    await httpClient.delete(`${GoalsService.BASE_URL}/${id}`);
  }

  static async listContributions(goalId: string): Promise<{ contributions: GoalContribution[] }> {
    const raw = await httpClient.get<any>(`${GoalsService.BASE_URL}/${goalId}/contributions`);
    return (raw as any).data || raw;
  }

  static async addContribution(goalId: string, data: AddContributionRequest): Promise<GoalContribution> {
    const raw = await httpClient.post<any>(`${GoalsService.BASE_URL}/${goalId}/contributions`, data);
    return (raw as any).data || raw;
  }

  static async deleteContribution(goalId: string, contribId: string): Promise<void> {
    await httpClient.delete(`${GoalsService.BASE_URL}/${goalId}/contributions/${contribId}`);
  }
}
